var app = angular.module('leonardo');


var WidgetAttachment = function(AttachmentService, FilterService, $http, ngDialog, AccountService,
                                AccountUserService, AuthDataService, NotificationService, FileService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/attachment.html',
    scope: {
      onAdd: '&',
      modeUpload: '=',
      overClass: '=',
      noManager: '=',
      noLink: '=',
      multiple: '=?',
      showManagement: '=?',
      disabled: '=ngDisabled',
      required: '=ngRequired',
      account: '=?',
      fileType: '=?',
      name: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.autoname = attrs.autoname ? true : false;
      scope.label = attrs.label? attrs.label : 'Drag your files here or click to upload';
      scope.links = [];
      scope.errorSize = false;
      scope.managedByMe = [];
      scope.managedToMe = [];

      switch (scope.fileType) {
        case 'image':
          scope.type = 'image/*';
          break;
        case 'excel':
          scope.type = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
          break;
        default:
          scope.type = '*';
      }

      function fetchAccountData() {
        if (AuthDataService.authData.account && AuthDataService.authData.account.id) {
          AccountService.get(AuthDataService.authData.account.id).then((result) => {
            scope.managedByMe = result.managed_by_me || [];
            scope.managedToMe = result.managed_to_me || [];
            // Call the visibility function after fetching data
            scope.showManagementCompanies(); // Ensure it gets updated
          });
        }
      }

      scope.showDisabled = function () {
        return scope.disabled && (scope.$parent.attachments.length === 0);
      };

      scope.showManagementCompanies = function () {
        return !AccountUserService.currentAccountUser.managed_by &&
          AuthDataService.isNotStaff() &&
          scope.showManagement &&
          AuthDataService.authData.account &&
          ((scope.managedToMe.length > 0) || (scope.managedByMe.length > 0));
      };

      // Initial fetch
      fetchAccountData();

      scope.getSector = function() {
        if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
          return FilterService.hasFilter('sector') ? FilterService.getFilter('sector') : null;
        }
        return null;
      };

      scope.removeLink = function(index) {
        if (scope.disabled) {
          return;
        }
        var links = angular.copy(scope.links);
        angular.forEach(scope.links, function(value, key){
          if (key > index) {
            links[key-1] = links[key];
          }
        });
        links.splice(links.length-1, 1);
        scope.links = links;
      };

      scope.showDocManager = function() {
        if (scope.disabled) return;
        scope.errorSize = false;
        ngDialog.openConfirm({
          template: 'views/templates/dialog/folder/selector.html',
          controller: 'FolderSelectorDialog',
          data: {
            sector: scope.getSector(),
            mode_folder: 'files',
            action:'select',
            account: scope.account
          }
        }).then(function(file) {
          if (file){
            if (file.document_file) {
              $http.get(file.destiny.file, {responseType : 'blob'}).then(function(data){
                var filename = file.destiny.file.split('/');
                scope.file = new FileService([file.destiny.file], filename[filename.length - 1], {
                  type: data.data.type,
                  lastModified: moment()
                });
                scope.file.name = file.destiny.name;
                scope.file.document_file = file.destiny.id;
                scope.submit();
              });
            }
            else {
              scope.file = {
                name: file.destiny.name,
                document_folder: file.destiny.id
              };
              scope.submit();
            }
          }
        });
      };

      scope.onWidgetAttachemntFileUpload = function(file) {
        if (scope.disabled || !file) {
          return;
        }
        if (scope.autoname) {
          scope.submit();
        }
      };

      scope.addLink = function() {
        if (scope.disabled || !scope.link) {
          return;
        }
        scope.errorSize = false;
        if (!scope.link.startsWith("https")) {
          scope.link = 'https://' + scope.link;
        }
        var name = scope.link.substring(0, 255);
        var attachment = {};
        if (scope.showManagementCompanies()) {
          ngDialog.openConfirm({
            template: 'views/templates/dialog/attachment/managers.html',
            data: {
              managers: AuthDataService.authData.account ? AuthDataService.authData.account.accountsAvailables().$object : []
            }
          }).then(function (result) {
            if (scope.modeUpload === 'upload_note'){
              attachment = {
                link: scope.link,
                name: name,
                available_for_account: result
              };
              scope.ngModelCtrl.$setViewValue(attachment);
            }
            else {
              attachment = {
                link: scope.link,
                name: name,
                available_for_account: result,
                promise: AttachmentService.post(name, null, scope.link, result)
              };
            }
            scope.onAdd({attachment: attachment});
            scope.link = '';
          }, function () {
            return;
          });
        }
        else {
          if (scope.modeUpload === 'upload_note'){
            attachment = {
              link: scope.link,
              name: name
            };
            scope.ngModelCtrl.$setViewValue(attachment);
          }
          else {
            attachment = {
              link: scope.link,
              name: name,
              promise: AttachmentService.post(name, null, scope.link)
            };
          }
          scope.onAdd({attachment: attachment});
          scope.link = '';
        }
      };

      scope.submit = function() {
        if (scope.disabled) {
          return;
        }
        scope.errorSize = AttachmentService.checkErrorSize(scope.file);
        if (scope.errorSize) {
          return;
        }
        if (scope.showManagementCompanies()) {
          ngDialog.openConfirm({
            template: 'views/templates/dialog/attachment/managers.html',
            data: {
              managers: AuthDataService.authData.account ? AuthDataService.authData.account.accountsAvailables().$object : []
            }
          }).then(function (result) {
            if (angular.isArray(scope.file)) {
              angular.forEach(scope.file, function (file) {
                var name = scope.autoname ? file.name : scope.name;
                var attachment = {};
                if (file.document_file || file.document_folder) {
                  attachment = file;
                  attachment.available_for_account = result;
                  scope.ngModelCtrl.$setViewValue(attachment);
                }
                else if (scope.modeUpload === 'upload_note') {
                  attachment = {
                    file: file,
                    name: name,
                    type: file.type,
                    available_for_account: result
                  };
                  scope.ngModelCtrl.$setViewValue(attachment);
                }
                else {
                  attachment = {
                    file: file,
                    name: name,
                    type: file.type,
                    available_for_account: result,
                    promise: AttachmentService.post(name, file, null, result)
                  };
                }
                scope.onAdd({attachment: attachment});
              });
            }
            else {
              var attachment = {};
              var name = scope.autoname ? scope.file.name : scope.name;
              if (scope.file.document_file || scope.file.document_folder) {
                attachment = scope.file;
                attachment.available_for_account = result;
                scope.ngModelCtrl.$setViewValue(attachment);
              }
              else if (scope.modeUpload === 'upload_note') {
                attachment = {
                  file: scope.file,
                  name: name,
                  type: scope.file.type,
                  available_for_account: result
                };
                scope.ngModelCtrl.$setViewValue(attachment);
              }
              else {
                attachment = {
                  file: scope.file,
                  name: name,
                  type: scope.file.type,
                  available_for_account: result,
                  promise: AttachmentService.post(name, scope.file, null, result)
                };
              }
              scope.onAdd({attachment: attachment});
            }
          }, function () {
            return;
          });
        }
        else {
          if (angular.isArray(scope.file)) {
            angular.forEach(scope.file, function (file) {
              var name = scope.autoname ? file.name : scope.name;
              var attachment = {};
              if (file.document_file || file.document_folder) {
                attachment = file;
                scope.ngModelCtrl.$setViewValue(attachment);
              }
              else if (scope.modeUpload === 'upload_note') {
                attachment = {
                  file: file,
                  name: name,
                  type: file.type
                };
                scope.ngModelCtrl.$setViewValue(attachment);
              }
              else {
                attachment = {
                  file: file,
                  name: name,
                  type: file.type,
                  promise: AttachmentService.post(name, file)
                };
              }
              scope.onAdd({attachment: attachment});
            });
          }
          else {
            var attachment = {};
            var name = scope.autoname ? scope.file.name : scope.name;
            if (scope.file.document_file || scope.file.document_folder) {
              attachment = scope.file;
              scope.ngModelCtrl.$setViewValue(attachment);
            }
            else if (scope.modeUpload === 'upload_note') {
              attachment = {
                file: scope.file,
                name: name,
                type: scope.file.type
              };
              scope.ngModelCtrl.$setViewValue(attachment);
            }
            else {
              attachment = {
                file: scope.file,
                name: name,
                type: scope.file.type,
                promise: AttachmentService.post(name, scope.file)
              };
            }
            scope.onAdd({attachment: attachment});
          }
        }
      };

      scope.showErrorRequired = function () {
        if ((!scope.formCtrl.$submitted) || (!scope.required)) {
          return false;
        }
        var value = scope.ngModelCtrl.$modelValue || scope.ngModelCtrl.$viewValue;
        if(value) {
          if (angular.isArray(value)) {
            return (value.length === 0);
          }
          else {
            return isNull(value);
          }
        }
      };

    }
  };
};

app.directive('widgetAttachment', ['AttachmentService', 'FilterService', '$http', 'ngDialog',
  'AccountService', 'AccountUserService', 'AuthDataService', 'NotificationService', 'FileService', WidgetAttachment]);
